import { useLocalization } from "@fluent/react";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const StatusFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
  hideFilterStatus,
}: FilterType & { hideFilterStatus?: string[] }) => {
  const { l10n } = useLocalization();
  const label = l10n.getString(FILTER_CONFIG[FilterChips.STATUS].labelKey);
  const filterOptions = hideFilterStatus
    ? FILTER_CONFIG[FilterChips.STATUS].options.filter(({ key }) =>
        !hideFilterStatus.includes(key)
      )
    : FILTER_CONFIG[FilterChips.STATUS].options;

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.STATUS}
      filterOptions={filterOptions}
      label={label}
    />
  );
};

export default StatusFilter;
